import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import LoadingIcon from "../../../../components/LoadingIcon";
import Guideline from "../components/Guideline";

import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import { logos } from "../../environment/icons/iconExport";
import IntegrationGuideAlert from "../components/IntegrationGuideAlert";
import AWSManageAccounts from "./AWSManageAccounts";
import AWSMemberOrganization from "./AWSMemberOrganization";
import AWSRootOrganization from "./AWSRootOrganization";
import AWSStandaloneAccounts from "./AWSStandaloneAccounts";

const AWSIntegration = () => {
  const { isIntegrated, isIntegratedLoading } = useIsIntegrated("aws");
  const [userPermissions, setUserPermissions] = useState([]);
  const [valueTab, setValueTab] = useState(0);
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);

  const { getAWSUserPermissions } = useAPI();
  const [awsRegionOptions, setAWSRegionOptions] = useState({
    "us-east-1": "N. Virginia",
    "us-east-2": "Ohio",
    "us-west-1": "N. California",
    "us-west-2": "Oregon",
    "af-south-1": "Cape Town",
    "ap-east-1": "Hong Kong",
    "ap-south-1": "Mumbai",
    "ap-south-2": "Hyderabad",
    "ap-southeast-1": "Singapore",
    "ap-southeast-2": "Sydney",
    "ap-southeast-3": "Jakarta",
    "ap-southeast-4": "Melbourne",
    "ap-southeast-5": "Kuala Lumpur",
    "ap-northeast-1": "Tokyo",
    "ap-northeast-2": "Seoul",
    "ap-northeast-3": "Osaka",
    "ca-central-1": "Canada Central",
    "ca-west-1": "Canada West (Calgary)",
    "eu-central-1": "Frankfurt",
    "eu-central-2": "Zurich",
    "eu-west-1": "Ireland",
    "eu-west-2": "London",
    "eu-west-3": "Paris",
    "eu-north-1": "Stockholm",
    "eu-south-1": "Milan",
    "eu-south-2": "Spain",
    "il-central-1": "Tel Aviv",
    "me-south-1": "Bahrain",
    "me-central-1": "UAE",
    "sa-east-1": "São Paulo",
  });
  const awsRegions = Object.entries(awsRegionOptions)
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    getAWSUserPermissions()
      .then((response) => setUserPermissions(response.data))
      .catch((error) => console.error(error));
  }, []);

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  if (isIntegratedLoading) {
    return <LoadingIcon />;
  }

  return (
    <Box>
      <Guideline
        title={
          !isIntegrated
            ? "Once integrated, Breeze will scan your AWS environment for misconfigurations and vulnerabilities."
            : ""
        }
        image={logos.AWSLogo}
        name={"Amazon Web Services"}
        iconHeight={30}
        iconWidth={50}
        iconBorderRadius={0}
        content={
          isIntegratedLoading ? (
            <LoadingIcon size={25} />
          ) : (
            <>
              {!isIntegrated && !guideMode && (
                <Typography variant={"h6"}>
                  Do you want to integrate single account or the entire
                  organization?
                </Typography>
              )}
              {guideMode && <IntegrationGuideAlert />}
              <br></br>

              <Tabs
                value={valueTab}
                onChange={handleChangeTab}
                sx={{ textTransform: "none" }}
              >
                <Tab label="1. Root Account" sx={{ textTransform: "none" }} />
                <Tab
                  label="2. All Member Accounts"
                  sx={{ textTransform: "none" }}
                />
                <Tab
                  label="3. Single Member Account"
                  sx={{ textTransform: "none" }}
                />

                <Tab
                  label="4. Manage Accounts"
                  sx={{ textTransform: "none" }}
                  disabled={!isIntegrated}
                />
              </Tabs>
              {valueTab === 0 && (
                <AWSRootOrganization
                  awsRegionOptions={awsRegions}
                  userPermissions={userPermissions}
                />
              )}
              {valueTab === 1 && (
                <AWSMemberOrganization
                  userPermissions={userPermissions}
                  awsRegionOptions={awsRegions}
                  guideMode={guideMode}
                />
              )}
              {valueTab === 2 && (
                <AWSStandaloneAccounts
                  userPermissions={userPermissions}
                  awsRegionOptions={awsRegions}
                  guideMode={guideMode}
                />
              )}
              {valueTab === 3 && (
                <AWSManageAccounts
                  awsRegionOptions={awsRegions}
                  guideMode={guideMode}
                />
              )}
            </>
          )
        }
      />
    </Box>
  );
};

export default AWSIntegration;
